import { render, staticRenderFns } from "./PrizeReceivedModal.vue?vue&type=template&id=5f948c59&scoped=true&"
import script from "./PrizeReceivedModal.vue?vue&type=script&lang=js&"
export * from "./PrizeReceivedModal.vue?vue&type=script&lang=js&"
import style0 from "./PrizeReceivedModal.vue?vue&type=style&index=0&id=5f948c59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f948c59",
  null
  
)

export default component.exports